import { render, staticRenderFns } from "./IpAccess.vue?vue&type=template&id=2d1a19a3"
import script from "./IpAccess.vue?vue&type=script&lang=js"
export * from "./IpAccess.vue?vue&type=script&lang=js"
import style0 from "./IpAccess.vue?vue&type=style&index=0&id=2d1a19a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports